import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    h: "Acceptance of terms",
    b: "By accessing or using the Vaultavo website (vaultavo.com), you agree to these Terms of Use. If you do not agree, do not use the website. These Website Terms of Use govern public marketing pages only; access to the Vaultavo platform, hardware, and APIs is governed by separate institutional agreements.",
  },
  {
    h: "No financial or legal advice",
    b: "Content on this website is provided for general information about Vaultavo's products, infrastructure, and institutional positioning. It does not constitute investment, financial, legal, regulatory, tax, or custody advice. You should obtain independent professional advice before making decisions based on this content.",
  },
  {
    h: "Intellectual property",
    b: "All trademarks, service marks, logos, copy, designs, and other materials displayed on this website are the property of Vaultavo or its licensors. No licence is granted to copy, reproduce, modify, redistribute, or commercially exploit any portion of the website except as expressly permitted in writing by Vaultavo.",
  },
  {
    h: "Forward-looking statements",
    b: "Statements regarding planned certifications, roadmap items, partnerships, and product evolution are forward-looking and may change without notice. Vaultavo does not warrant that any planned item will be delivered, certified, or available on any particular timeline.",
  },
  {
    h: "Third-party links",
    b: "The website may link to third-party sites. Vaultavo is not responsible for the content, accuracy, or practices of any third-party site.",
  },
  {
    h: "Limitation of liability",
    b: "To the maximum extent permitted by law, Vaultavo and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the website.",
  },
  {
    h: "Governing law",
    b: "These Terms are governed by the laws of the jurisdiction in which the contracting Vaultavo entity is incorporated, without regard to its conflict of laws provisions.",
  },
  {
    h: "Contact",
    b: "Questions about these Terms: hello@vaultavo.com",
  },
];

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      kicker="Terms of Use"
      title="Website Terms of Use."
      summary="The terms that govern access to and use of the public Vaultavo website. Institutional services are governed by separate written agreements."
      lastUpdated="Feb 2026"
      sections={SECTIONS}
    />
  );
}
